<template>   
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>
    <b-row class="text-center">
        <b-col cols="12">          
          <div style="margin-bottom:10px"></div>
            
            <div style="margin: 10px"></div>
              <b-card bg-variant="light" style="min-height: 60vh;">
                <div class="col-md-12">                   
                    <div class="overflow-auto">
                      <b-table stacked="md" id="my-table" striped small :fields="fields" :items="corredores" responsive="sm"  :per-page="perPage" :current-page="currentPage">
                        <template  v-slot:cell(codigo)="data">
                           <span>{{data.item.idCorredor}}</span>                                         
                        </template>
                        <template v-slot:cell(status)="data">
                          <span>{{ data.item.status === 'A' ? 'Ativo' : 'Inativo' }}</span>
                        </template>
                        <template  v-slot:cell(visualizar)="data">
                            <b-button @click="visualizar(data.item.idCorredor)" class="v-button" size="sm" style="background-color: #303f9f; margin-right: 5px"><b-icon icon="search"></b-icon></b-button>                                         
                            <b-button @click="remover(data.item.idCorredor)" class="v-button" size="sm" variant="danger"><b-icon icon="trash"></b-icon></b-button>                                                                                  
                        </template>
                      </b-table>
                      <div style="float: right">
                      </div>                      
                    </div>
                </div>
              </b-card>
              <br>
              <b-card bg-variant="light">
                <div class="row" style="float: right">
                    <b-button v-b-modal.modal-corredor style="margin-right: 30px; background-color: #303f9f">
                      <b-icon icon="file-earmark"></b-icon>  Novo
                    </b-button>   
                </div>
              </b-card>
        </b-col>
      </b-row>
      <b-modal id="modal-corredor" ref="modal" title="Corredor" @hidden="resetModal" @ok="salvar" >
                <b-form-group label="Descrição" label-for="name-input"  >
                    <b-input id="name-input" v-model="corredor.descricao" ></b-input>
                </b-form-group>
                <b-form-group label="Status" label-for="status-input">
                    <b-select id="status-input" v-model="corredor.status" :options="statusOptions"></b-select>
                </b-form-group>
        </b-modal>  
    </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';

export default {
  components: { BarraNavegacao },

  data(){
    return{
      corredores: [],
      fields: ['descricao', 'status', { key: 'visualizar', label: 'Visualizar' , class:'text-center'}],
      corredor: {idCorredor: null, descricao: '', status: 'A'},
      statusOptions: [
        { value: 'A', text: 'Ativo' },
        { value: 'I', text: 'Inativo' }
      ],
      perPage: 10,
      currentPage: 1
    }
  },

  created(){
    this.validaAcesso();
  },

  mounted(){
    this.listar();
  },

  methods: {

    alertaMensager(mensagem,titulo,tipo){
          this.$fire({
              title: titulo,
              text: mensagem,
              type: tipo,
              }).then(r => {
               r.value;
            });
        },

    resetModal() {
        this.corredor= {idCorredor: null, descricao: '', status: 'A'}
    },

    salvar(){
        this.$http.post('/corredores', this.corredor).then(() => {
             this.alertaMensager("Salvo com sucesso","","success");   
             this.listar();      
          }).catch(() => {
             this.alertaMensager("Erro ao salvar", "", "error");
          })
    },

    validaAcesso(){
        this.$http.get('/gerencia').then();
    },

    listar(){
      this.$http.get("/corredores").then(res => {
         this.corredores = res.data;
      }) 
    },

    visualizar(id){
      this.$http.get("/corredores/"+id).then(res => {
         this.corredor = res.data;
         this.$bvModal.show('modal-corredor');
      }) 
    },

    remover(id){
        this.$confirm("Tem certeza que deseja excluir o corredor ?").then(() => {
            this.$http.delete("/corredores/"+id).then(res => {
                if(res.status == 200 || res.status == 204){
                    this.alertaMensager("","Corredor excluído com sucesso","success");
                    this.listar();
                }else{
                    this.alertaMensager("","Erro ao excluir","error");
                }
            }).catch(() => {
                this.alertaMensager("","Erro ao excluir","error");
            })
        });
      
    }
    
  }
}

</script>

<style>

</style>
